import { service } from "@server/client";
import type {
  GetOrderQuery,
  GetOrderQueryVariables,
} from "@server/gql/graphql";
import { getOrderQuery } from "@server/queries/checkout";

export const getOrder = async (variables: GetOrderQueryVariables) => {
  try {
    const response = await service<GetOrderQuery, GetOrderQueryVariables>({
      query: getOrderQuery,
      variables,
    });

    return response.order;
  } catch (error: Error | unknown) {
    console.error("Error in getOrder", error);
    throw error;
  }
};
